/**
 * Shared environment detection.
 *
 * A build counts as "development" when it is a CRA dev build, or when it is served
 * from localhost or a `dev.` host (the deployed development Cloud Run service).
 * Mirrors the backend's FLASK_ENV development/test check in
 * `backend/google_api_client.py::is_dev_environment`.
 */
export const isDevEnvironment = () =>
  process.env.NODE_ENV === 'development' ||
  window.location.hostname.includes('localhost') ||
  window.location.hostname.includes('dev.');

export const BASE_APP_TITLE = 'Reseller Portal';
export const DEV_TITLE_SUFFIX = 'DEVELOPMENT (No actions are live)';

export const JIRA_PROD_URL = 'https://xebia.atlassian.net';
export const JIRA_SANDBOX_URL = 'https://xebia-cloud-sandbox.atlassian.net';

/**
 * Returns the Jira base URL for the current environment:
 * Sandbox in development/test/staging (localhost, dev.*), production URL otherwise.
 * Can be overridden via REACT_APP_JIRA_URL.
 */
export const getJiraBaseUrl = () => {
  if (process.env.REACT_APP_JIRA_URL) {
    return process.env.REACT_APP_JIRA_URL.replace(/\/+$/, '');
  }
  return isDevEnvironment() ? JIRA_SANDBOX_URL : JIRA_PROD_URL;
};

/**
 * The page title for the current environment: the plain product name in
 * production, flagged with the DEVELOPMENT marker everywhere else.
 */
export const getAppTitle = () =>
  isDevEnvironment() ? `${BASE_APP_TITLE} - ${DEV_TITLE_SUFFIX}` : BASE_APP_TITLE;
